import { createContext, useContext } from "react";

/**
 * Tỉ lệ thu nhỏ toàn app (đặt bởi LayoutApp, xem src/layout/LayoutApp.jsx) —
 * cần thiết cho các phần tử PORTAL thẳng ra document.body (fixed pinned vào
 * viewport thật, vd SocialLinks) vì portal khiến chúng nằm NGOÀI cây bị
 * transform:scale nên không còn tự động ăn theo tỉ lệ đó -> phải đọc context
 * này rồi tự áp `transform: scale(...)` để vẫn thu nhỏ đồng bộ với phần còn
 * lại của trang.
 */
const AppScaleContext = createContext({ scale: 1, isMobile: false });

export const AppScaleProvider = AppScaleContext.Provider;

export const useAppScale = () => useContext(AppScaleContext);

export default AppScaleContext;
